import { render, staticRenderFns } from "./Endereco.vue?vue&type=template&id=699312e7&scoped=true"
import script from "./Endereco.vue?vue&type=script&lang=js"
export * from "./Endereco.vue?vue&type=script&lang=js"
import style0 from "./Endereco.vue?vue&type=style&index=0&id=699312e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699312e7",
  null
  
)

export default component.exports